import { jsonIf } from '../utils/utils.network';

export const getSuggestions = async (search) => {
  const url = `${process.env.BASE_URL}/${process.env.V_PREFIX}/vehicles/models/?textSearch=${search}&limit=10&vehicleClass=usedcar&applicationFilter=consumer&api_key=${process.env.API_KEY}`;
  return fetch(url, {
    headers: {
      referer: `${process.env.BASE_URL}`,
      authorization: `Basic ${process.env.ICO_TOKEN}`,
    },
    method: 'GET',
    mode: 'cors',
  })
    .then((res) => jsonIf(res))
    .then((resJson) => {
      resJson.data.map((x) => (x.trimId = x.vehicleId));
      return resJson.data.slice(0, 10) || [];
    })
    .catch((error) => {
      console.log(`Error when getting Suggestions for text '${search}'. Response status ${error}`);
      return '';
    });
};

export const getHealthCheck = () => {
  const url = `${process.env.BASE_URL}/${process.env.V_PREFIX}/health/alive?api_key=${process.env.API_KEY}`;
  return fetch(url, {
    headers: {
      referer: `${process.env.BASE_URL}`,
      authorization: `Basic ${process.env.ICO_TOKEN}`,
    },
    method: 'GET',
    mode: 'cors',
  }).then((res) => res);
};
